module.exports = __webpack_public_path__ + "static/media/au.f6b7907c.svg";